module.exports = __webpack_public_path__ + "static/media/4633.6c3cfabe.jpg";